var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#001D52",
    d: "M11 13.5H8.167V10a1.168 1.168 0 0 0-2.333 0v3.5H3C1.388 13.5.5 12.612.5 11V6.767c0-1.416.39-1.811 1.028-2.34l4.08-3.42a2.16 2.16 0 0 1 2.784 0l4.08 3.42c.637.529 1.028.925 1.028 2.34V11c0 1.612-.888 2.5-2.5 2.5m-1.833-1H11c1.051 0 1.5-.449 1.5-1.5V6.767c0-1.018-.168-1.157-.666-1.57L7.75 1.773a1.17 1.17 0 0 0-1.5 0L2.166 5.197c-.498.413-.666.552-.666 1.57V11c0 1.051.449 1.5 1.5 1.5h1.833V10A2.17 2.17 0 0 1 7 7.833 2.17 2.17 0 0 1 9.167 10z"
  })));
};
export default SvgHome;